// Small pure helpers shared by the index-based list editors (rules documents,
// battle tactics). Battleplans reorder by name key in the workspace, so they
// don't use these — but every sidebar that tracks selection by index does.

/** Move item `from` → `to`, returning a new array. No-op (returns input) for out-of-range or equal indices. */
export function reorder<T>(items: T[], from: number, to: number): T[] {
  if (from < 0 || from >= items.length || to < 0 || to >= items.length || from === to) {
    return items;
  }
  const next = [...items];
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}

/** Where a tracked selection lands after a `from → to` move, so selection follows its item. */
export function reorderedSelection(from: number, to: number, selected: number): number {
  if (selected === from) return to;
  if (from < selected && to >= selected) return selected - 1;
  if (from > selected && to <= selected) return selected + 1;
  return selected;
}
